import React, {useState, useEffect} from "react";
import { Row, Col } from 'react-bootstrap';
import { Link } from "gatsby";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import PropertyWorthModule from "../../how-much-property-worth-module";
import { AllNews, AllNewsByCategory } from "../../../queries/common_use_query";
import { AltSiteName, NewsBaseURL } from "../../utils";
import "./NewsList.scss";

const postsPerPage = 9;
let arrayForHoldingPosts = [];

const NewsList = ({categorySlug}) => {

    const { loading, error, data } = categorySlug ? AllNewsByCategory(0, -1, categorySlug) : AllNews(0, -1);

    const [postsToShow, setPostsToShow] = useState([]);
    const [next, setNext] = useState(9);

    useEffect(() => {
        arrayForHoldingPosts = [];
    }, []);

    const loopWithSlice = (start, end) => {
        const slicedPosts = data.newsBlogs.slice(start, end);
        arrayForHoldingPosts = [...arrayForHoldingPosts, ...slicedPosts];
        setPostsToShow(arrayForHoldingPosts);
    };
    const handleShowMorePosts = () => {
        loopWithSlice(next, next + postsPerPage);
        setNext(next + postsPerPage);
    };

    useEffect(() => {
        data && loopWithSlice(0, postsPerPage);
    }, [data]);

    var no_news= false;
    if(data && data.newsBlogs.length === 0) {
        no_news = true;
    }

    const ImageRenderList = ({ item, processedImages }) => {
        return (
            <ImageTransform imagesources={item.Tile_Image.url} renderer="srcSet" imagename="news-blogs.Tile_Image.commontile" attr={{ alt: item.Tile_Image.alternativeText?item.Tile_Image.alternativeText:item.Title+AltSiteName}} imagetransformresult={processedImages} id={item.id}/>  
        )
    }

    return (
        <section className="news-listings-grid">
                <Row className="no-post-results">
                    <Col>
                        {no_news === true &&
                            <p className="text-center">There is no news/blogs listed under this category</p>
                        }
                    </Col>
                </Row>
                <Row className="news-post-grid">
                {postsToShow && postsToShow.length > 0 && postsToShow.map((item, index) => {
                    let processedImages = JSON.stringify({});
                    if (item?.imagetransforms?.Tile_Image_Transforms) {
                        processedImages = item.imagetransforms.Tile_Image_Transforms;
                    }
                    return (
                        <>
                        <Col md={6} lg={4} className="news-post-grid-item">
                            <div className="post-grid-img img-zoom list-news-tile">
                                <Link to={`${NewsBaseURL}/${item.Select_News_Category?.URL}/${item.URL}/`} className="img-link">
                                    <ImageRenderList processedImages={processedImages} item={item} />
                                    {item?.Select_News_Category?.Name && <span className="category-tag">{item.Select_News_Category?.Name}</span>}
                                </Link>
                           </div>
                           <div className="post-info">
                                <h2><Link to={`${NewsBaseURL}/${item.Select_News_Category?.URL}/${item.URL}/`}>{item.Title}</Link></h2>
                           </div>
                        </Col>
                         {index == 5 &&
                            <div className="property-wrapper news-how-much-module">
                                <PropertyWorthModule/>
                            </div>
                        } 
                        </>
                    )
                })}
                </Row>
                <Row className="load-pagination">
                    {postsToShow && postsToShow.length > 8 && postsToShow.length >= next &&
                        <a onClick={handleShowMorePosts} className="btn load-more-post">Load More News</a>
                    } 
                </Row>
        </section>
    )
};
export default NewsList;